import React from 'react';
import { useQuery } from '@apollo/client';
import PropTypes from 'prop-types';
import { FullPageSpinner } from 'admin-components/components';
import { GET_PAYMENT_METHODS, GET_REFUND_METHODS } from 'store/queries';
import AgentPortalError from 'errors/AgentPortalError';

const GetPaymentMethodsQuery = ({ children, reference, isRefund }) => {
  const { loading, error, data } = useQuery(isRefund ? GET_REFUND_METHODS : GET_PAYMENT_METHODS, {
    variables: { bookingReference: reference },
    fetchPolicy: 'network-only'
  });

  if (loading) {
    return <FullPageSpinner />;
  }
  if (error) {
    throw new AgentPortalError(error);
  }

  const getMethodType = isRefund ? 'refundMethods' : 'paymentMethods';

  const paymentMethods = data[getMethodType];

  return children({ data: { paymentMethods } });
};

GetPaymentMethodsQuery.propTypes = {
  reference: PropTypes.string,
  children: PropTypes.func,
  isRefund: PropTypes.bool
};

export default GetPaymentMethodsQuery;
